import { Box } from '@wix/design-system';
import {
  PageDisclaimer,
  SkeletonBar,
  STUDIO_CARD_BORDER_COLOR,
  StudioCta,
} from '@wix/package-picker-shared-studio';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { PageSkeleton } from './PageSkeleton';

const CARDS_COUNT = 5;
const FEATURE_WIDTHS = ['131px', '148px', '117px', '131px', '158px', '131px'];

const PlanCardSkeleton = () => (
  <Box flex="1" minWidth="0" direction="vertical" gap="8px">
    <Box height="28px" />
    <Box
      height="563px"
      direction="vertical"
      gap="36px"
      padding="20px"
      boxSizing="border-box"
      borderRadius="12px"
      border={`1px solid ${STUDIO_CARD_BORDER_COLOR}`}
      backgroundColor="white"
    >
      <Box direction="vertical" gap="39px">
        <Box direction="vertical">
          <Box height="32px" verticalAlign="middle">
            <SkeletonBar width="67px" height="20px" />
          </Box>
          <Box height="18px" verticalAlign="middle">
            <SkeletonBar width="147px" height="12px" />
          </Box>
        </Box>
        <Box direction="vertical" gap="10px">
          <Box direction="vertical" gap="4px">
            <Box verticalAlign="bottom" gap="10px">
              <SkeletonBar width="89px" height="28px" />
              <SkeletonBar width="47px" height="12px" />
            </Box>
            <Box height="18px" />
          </Box>
          <SkeletonBar width="100%" height="38px" />
        </Box>
      </Box>
      <Box direction="vertical" gap="16px">
        {FEATURE_WIDTHS.map((width, index) => (
          <Box key={index} height="21px" verticalAlign="middle" padding="0 2px">
            <SkeletonBar width={width} height="10px" />
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
);

export const PlansStepSkeleton = () => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();

  return (
    <PageSkeleton dataHook="plans-step-skeleton">
      <Box width="100%" gap="12px" marginTop="SP8">
        {Array.from({ length: CARDS_COUNT }, (_, index) => (
          <PlanCardSkeleton key={index} />
        ))}
      </Box>
      <Box marginTop="SP4" pointerEvents="none">
        <StudioCta
          size="medium"
          fullWidth={false}
          onClick={() => {}}
          tabIndex={-1}
          aria-hidden
        >
          {t('premium-purchase-plan.cards.compare_features.cta')}
        </StudioCta>
      </Box>
      <Box
        width="100%"
        marginTop="SP4"
        padding="20px 40px 0"
        boxSizing="border-box"
        textAlign="center"
        align="center"
      >
        <PageDisclaimer />
      </Box>
    </PageSkeleton>
  );
};
